import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{attrs:{"id":"rr-vue"}},[_c('TheDebugBar'),_c(VMain,{style:(_vm.compBg),attrs:{"dark":_vm.setTheme()}},[_c(VContainer,{staticClass:"fill-height",attrs:{"fluid":""}},[_c(VLayout,{attrs:{"align-center":"","justify-center":""}},[_c(VFlex,{attrs:{"xs12":"","sm8":"","md6":""}},[_vm._t("default")],2)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }